import * as React from 'react';
import {COMMON} from '../../constants/LabelConstants';
import AssetsManager from '../../utils/AssetsManager';

const ErrorWithRetryView: React.FC = props => (
    <div className="text-center px-3 py-2">
        <img className="py-3" src={AssetsManager('/assets/images/common/sad-icon.svg')}/>
        <h5 className="main-title pt-3">{COMMON.ERROR_TITLE}</h5>
        <h5 className="main-title pb-3">{COMMON.ERROR_MESSAGE}</h5>
        <p className="">{COMMON.RETRY_MESSAGE}</p>
    </div>
);

export default ErrorWithRetryView;
